import {
  ADD_PATIENT_ALLERGY,
  ADD_PATIENT_ALLERGY_ERROR,
  BACK_IN_QUEUE,
  BACK_IN_QUEUE_ERROR,
  CHANGE_IS_VISIT_ENDED,
  CLEAR_STALE_CALL_TOKENS,
  COMPLETE_VISIT_CALL_SUCCESS,
  DELETE_PATIENT_ALLERGY,
  DELETE_PATIENT_ALLERGY_ERROR,
  DELETE_VISIT_NOTES,
  DELETE_VISIT_NOTES_ERROR,
  DELETE_VISIT_PATIENT_INSTRUCTIONS,
  DELETE_VISIT_PATIENT_INSTRUCTIONS_ERROR,
  END_VISIT,
  END_VISIT_ERROR,
  GET_PATIENT_PRESCRIPTIONS,
  GET_PATIENT_PRESCRIPTIONS_ERROR,
  GET_PATIENT_TREAT_URL,
  GET_PATIENT_TREAT_URL_ERROR,
  GET_PATIENTS,
  GET_PATIENTS_ERROR,
  GET_PHONE_CALL_TOKEN,
  GET_PHONE_CALL_TOKEN_ERROR,
  GET_PHONE_CALL_TOKEN_SUCCESS,
  GET_PROVIDER,
  GET_PROVIDER_ERROR,
  GET_VISIT_INFO,
  GET_VISIT_INFO_ERROR,
  GET_VISIT_INFO_SUCCESS,
  GET_VISIT_PATIENT_CHART,
  GET_VISIT_PATIENT_CHART_ERROR,
  GET_VISIT_PATIENT_CHART_SUCCESS,
  LEAVE_VISIT_ROOM,
  SAVE_VISIT_NOTES,
  SAVE_VISIT_NOTES_ERROR,
  SAVE_VISIT_PATIENT_INSTRUCTIONS,
  SAVE_VISIT_PATIENT_INSTRUCTIONS_ERROR,
  SEARCH_FOR_ICD_CODES,
  SEARCH_FOR_ICD_CODES_ERROR,
  SET_ERROR as SET_ERROR_WAITING_ROOM,
  SET_FORCE_UPDATE_WAITING_ROOM,
  SET_LOADING as SET_LOADING_WAITING_ROOM,
  SET_VISIT_INFO,
  SET_VISIT_ROOM,
  START_VISIT_VIDEO_CALL,
  START_VISIT_VIDEO_CALL_ERROR,
  START_VISIT_VIDEO_CALL_SUCCESS,
  SUCCESS_VISIT,
  UPDATE_ICD_CODES,
  UPDATE_ICD_CODES_ERROR,
} from '../waitingRoom/WaitingRoomConstants'
// `inVisitRoom` is also written by the in-person entry path, whose action constant lives
// in the visits domain even though `WaitingRoomReducer.ts:674` is what handles it.
import { START_INPERSON_VISIT_SUCCESS } from '../visits/VisitsConstants'

export const waitingRoomReducerBlackListActions = [
  GET_PATIENTS,
  GET_PATIENTS_ERROR,
  GET_PROVIDER,
  GET_PROVIDER_ERROR,
  START_VISIT_VIDEO_CALL,
  START_VISIT_VIDEO_CALL_ERROR,
  GET_VISIT_INFO,
  GET_VISIT_INFO_ERROR,
  GET_PHONE_CALL_TOKEN,
  GET_PHONE_CALL_TOKEN_ERROR,
  GET_VISIT_PATIENT_CHART,
  GET_VISIT_PATIENT_CHART_ERROR,
  ADD_PATIENT_ALLERGY,
  ADD_PATIENT_ALLERGY_ERROR,
  DELETE_PATIENT_ALLERGY,
  DELETE_PATIENT_ALLERGY_ERROR,
  SAVE_VISIT_NOTES,
  SAVE_VISIT_NOTES_ERROR,
  SAVE_VISIT_PATIENT_INSTRUCTIONS,
  SAVE_VISIT_PATIENT_INSTRUCTIONS_ERROR,
  GET_PATIENT_PRESCRIPTIONS,
  GET_PATIENT_PRESCRIPTIONS_ERROR,
  GET_PATIENT_TREAT_URL,
  GET_PATIENT_TREAT_URL_ERROR,
  END_VISIT,
  END_VISIT_ERROR,
  DELETE_VISIT_NOTES,
  DELETE_VISIT_NOTES_ERROR,
  DELETE_VISIT_PATIENT_INSTRUCTIONS,
  DELETE_VISIT_PATIENT_INSTRUCTIONS_ERROR,
  SEARCH_FOR_ICD_CODES,
  SEARCH_FOR_ICD_CODES_ERROR,
  UPDATE_ICD_CODES,
  UPDATE_ICD_CODES_ERROR,
  BACK_IN_QUEUE,
  BACK_IN_QUEUE_ERROR,
  SET_LOADING_WAITING_ROOM,
  SET_ERROR_WAITING_ROOM,
  GET_PROVIDER,
  SET_VISIT_INFO,
  GET_VISIT_INFO_SUCCESS,
  GET_VISIT_INFO_ERROR,
  CHANGE_IS_VISIT_ENDED,
  SET_FORCE_UPDATE_WAITING_ROOM,
  START_VISIT_VIDEO_CALL_SUCCESS,
  GET_PHONE_CALL_TOKEN_SUCCESS,
  GET_VISIT_PATIENT_CHART_SUCCESS,
  CLEAR_STALE_CALL_TOKENS,
  // --- `inVisitRoom` writers: must never cross tabs. ---
  // `shouldSyncAction` broadcasts any non-blacklisted action, and redux-state-sync 3.1.2
  // applies the predicate on send AND receive, so these leaked in both directions:
  // SET_VISIT_ROOM / START_INPERSON_VISIT_SUCCESS ARMED a sibling tab that was not in a
  // visit (which then keeps the whole origin's idle timer alive via useInVisitKeepAlive),
  // and LEAVE_VISIT_ROOM DISARMED a sibling tab that genuinely was in a visit.
  // The other three writers — GET_PHONE_CALL_TOKEN_SUCCESS, START_VISIT_VIDEO_CALL_SUCCESS
  // and the visitNotStarted error arm — were already covered above.
  //
  // Known trade-off: `WaitingRoom.tsx:169` shows "Your visit has been started in different
  // browser tab/window" when `inVisitRoom` is true, so it reads as if it depends on this
  // state crossing tabs. It does not depend on THESE entries: the two primary arming
  // actions have been blacklisted on `develop` since before this work, so the guard has
  // long been unreachable from a normal phone or video visit. What that guard actually
  // gained from the leak was false positives — a tab holding stale `inVisitRoom: true` is
  // blocked from starting a legitimate visit and shown that error.
  SET_VISIT_ROOM,
  LEAVE_VISIT_ROOM,
  START_INPERSON_VISIT_SUCCESS,
  // These two became `inVisitRoom` writers when the visit-completion branch started
  // clearing the flag explicitly (it used to spread `initialVisitRoomState`, which does
  // not contain the key, so completion cleared nothing). That made them exactly the
  // DISARM case described above: tab B finishing an older visit would broadcast the
  // completion, tab A's reducer would run the new `inVisitRoom: false`, and tab A's
  // `useInVisitKeepAlive` would tear down mid-call — re-creating the mid-visit logout
  // this work exists to remove. Blacklisting them keeps the clear local to the tab that
  // actually ended a visit, which is the only tab it is true for.
  COMPLETE_VISIT_CALL_SUCCESS,
  SUCCESS_VISIT,
]
